import { render, staticRenderFns } from "./consultDetail.vue?vue&type=template&id=3b2fb6bc&scoped=true&"
import script from "./consultDetail.vue?vue&type=script&lang=js&"
export * from "./consultDetail.vue?vue&type=script&lang=js&"
import style0 from "./consultDetail.vue?vue&type=style&index=0&id=3b2fb6bc&scoped=true&lang=css&"
import style1 from "./consultDetail.vue?vue&type=style&index=1&id=3b2fb6bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2fb6bc",
  null
  
)

export default component.exports